import SkeletonLoader from '@/components/atoms/skeleton-loader/skeleton-loader';
import Container from '@/components/utilities/container/container';
import ModuleWrapper from '@/components/utilities/module-wrapper/module-wrapper';
import styles from './module-loading-fallback.module.scss';

export interface ModuleLoadingFallbackProps {
  height?: string;
}

const ModuleLoadingFallback = ({
  height = '120px',
}: ModuleLoadingFallbackProps) => {
  const wrapperHeight = `calc(${height} + var(--moduleWrapper-padding) + var(--moduleWrapper-padding))`;

  return (
    <ModuleWrapper
      className={styles.component}
      style={{ height: wrapperHeight }}
    >
      <Container>
        <SkeletonLoader
          className={styles.skeletonLoader}
          height="100%"
          width="100%"
        />
      </Container>
    </ModuleWrapper>
  );
};

ModuleLoadingFallback.displayName = 'ModuleLoadingFallback';

export default ModuleLoadingFallback;
